
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetoshirdicab() {



    const cardData =
    {
        keyword: 'Pune to Shirdi Cab',
        heading: 'S9 Travels:  Pune to Shirdi Cab',
        headingDescription: 'S9 Travels provides reliable and comfortable Pune to Shirdi cab services, ensuring a smooth and safe journey for devotees visiting the sacred Sai Baba Temple or families planning a spiritual weekend getaway. The distance between Pune and Shirdi is about 185 km, typically covered in 4 to 5 hours through scenic routes via Ahmednagar. Our fleet includes Innova Crysta, Ertiga, Swift Dzire, and Hatchback cabs, all well-maintained and driven by professional, courteous chauffeurs. Whether you’re looking for a one-way transfer, round trip, or customized travel package, S9 Travels guarantees on-time pickup, clean vehicles, and affordable fares. Experience a stress-free pilgrimage with our 24×7 cab booking support and trusted Pune to Shirdi taxi services designed for your comfort and convenience.',

        top: 'Top Places to Visit in Shirdi with S9 Travels',

"topPlaces": [
    {
      "title": "Shri Sai Baba Samadhi Mandir",
      "description": "The Shri Sai Baba Samadhi Mandir is the most revered temple in Shirdi, housing the final resting place of Sai Baba. Devotees from all over the world visit to seek blessings and experience the spiritual aura of the temple."
    },
    {
      "title": "Dwarkamai",
      "description": "Dwarkamai is a sacred mosque where Sai Baba spent a significant part of his life. It is believed to be a place of miracles, where Baba lit lamps with water and healed the sick. It remains a place of deep devotion for his followers."
    },
    {
      "title": "Chavadi",
      "description": "Chavadi holds great historical and spiritual significance as Sai Baba used to sleep here on alternate nights. The site is now a temple and plays an important role in religious processions in Shirdi."
    },
    {
      "title": "Shri Sai Baba Sansthan Trust Museum",
      "description": "This museum showcases various personal belongings of Sai Baba, including his clothing, utensils, and walking stick. It provides insights into his simple yet impactful life and teachings."
    },
    {
      "title": "Gurusthan",
      "description": "Gurusthan is believed to be the place where Sai Baba was first spotted meditating under a neem tree as a young ascetic. Devotees believe that lighting incense sticks here brings good health and prosperity."
    },
    {
      "title": "Khandoba Temple",
      "description": "This temple is dedicated to Lord Khandoba and is significant in Shirdi’s history. It is where Sai Baba was first recognized as a saint by a local priest, marking the beginning of his divine journey."
    },
    {
      "title": "Lendi Baug",
      "description": "Lendi Baug is a beautiful garden where Sai Baba used to meditate and water the plants. The garden has a sacred lamp (Nanda Deep) that Baba lit and which continues to burn today."
    },
    {
      "title": "Maruti Mandir",
      "description": "One of the oldest temples in Shirdi, Maruti Mandir is dedicated to Lord Hanuman. It is believed that Sai Baba often visited this temple, making it a place of spiritual significance."
    },
    {
      "title": "Sai Heritage Village",
      "description": "Sai Heritage Village is a unique theme park that showcases the life and miracles of Sai Baba through beautiful sculptures and dioramas. It’s an educational and devotional attraction for visitors."
    },
    {
      "title": "Wet N Joy Water Park",
      "description": "For those looking for some fun and relaxation, Wet N Joy Water Park in Shirdi offers thrilling water slides, wave pools, and family-friendly attractions, making it a great place to unwind after a spiritual visit."
    }
],

"services": [
  {
    "name": "Pune to Mumbai Airport Round Trip Innova Cab",
    "description": "Book a reliable round-trip Innova cab from Pune to Mumbai Airport with S9 Travels. Enjoy door-to-door pickup, timely drop-off, and a comfortable return journey with our well-maintained AC Innova fleet."
  },
  {
    "name": "Private Innova Taxi from Pune to Mumbai Airport",
    "description": "Prefer privacy? Our private Innova taxi service from Pune to Mumbai Airport ensures a peaceful, hassle-free ride — ideal for solo travelers, families, or executives seeking exclusive comfort."
  },
  {
    "name": "Affordable Innova Cabs from Pune to Mumbai Airport",
    "description": "Looking for a cost-effective ride without sacrificing comfort? Our affordable Innova taxis provide clean interiors, ample luggage space, and budget-friendly rates for Pune to Mumbai Airport transfers."
  },
  {
    "name": "Group Travel Innova Taxi to Mumbai Airport",
    "description": "Traveling in a group? Book a spacious Innova cab from Pune to Mumbai Airport. Great for families or colleagues with luggage, offering a smooth, air-conditioned journey for all."
  },
  {
    "name": "Luxury Innova Crysta to Mumbai Airport from Pune",
    "description": "Upgrade your airport travel with our luxury Innova Crysta service. Plush seating, chilled AC, and professional chauffeurs — perfect for VIP, business, or comfort-loving travelers from Pune to Mumbai Airport."
  }
],
  "tableData": [
    ["Pune to Mumbai Airport Round Trip Innova", "Private Innova Cab from Pune to Mumbai Airport"],
    ["Affordable Pune to Mumbai Airport Innova", "Group Travel to Mumbai Airport by Innova"],
    ["Luxury Innova for Mumbai Airport", "Pune to Mumbai Airport Round Trip Innova"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of arriving at your destination on time. Whether you're traveling from Pune to Shirdi, we ensure prompt pickups and a smooth journey. Our drivers are punctual and committed to getting you to Shirdi comfortably and on schedule."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our Toyota Innova is the ideal vehicle for your journey from Pune to Shirdi. With comfortable seating, air conditioning, and ample space for luggage, you can enjoy a relaxing and stress-free trip. Whether you're traveling alone or with family and friends, you’ll experience comfort throughout the ride."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are highly experienced and familiar with the best routes from Pune to Shirdi. They are courteous, knowledgeable, and dedicated to ensuring a smooth and enjoyable journey. With their expertise, you can relax and enjoy the trip without any concerns."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Pune to Shirdi cab ride. You’ll receive a clear breakdown of all costs before confirming your booking, with no hidden charges, allowing you to plan your travel comfortably."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. Our Toyota Innova vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking. You can rest assured that your journey from Pune to Shirdi will be secure and comfortable."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "No matter when you need to travel, S9 Travels is available 24/7. Whether you want to start your journey early in the morning or late in the evening, our rides are ready to serve you, and our customer service team is always available to assist you."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Shirdi cab is simple and hassle-free with S9 Travels. You can easily book your ride online through our website or mobile app, or contact our customer service team for personalized assistance in securing your cab."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We offer customized travel packages for your journey from Pune to Shirdi. Whether you need additional stops along the way or have specific preferences, we can tailor the trip to meet your needs and make your experience more enjoyable."
  }
]












    }



    const faqData = [
        [
          {
            question: 'How can I book a cab from Pune to Shirdi with S9 Travels?',
            answer: 'Booking a cab for your Pune to Shirdi trip is simple! You can book online through our website or mobile app, or contact our customer service team for assistance with your booking.'
          },
          {
            question: 'What types of cabs are available for Pune to Shirdi travel?',
            answer: 'We offer various cabs, including the spacious Toyota Innova, which is perfect for families, groups, or travelers with a lot of luggage. Choose the vehicle that best suits your needs for a comfortable journey.'
          },
          {
            question: 'Are the drivers experienced for the Pune to Shirdi route?',
            answer: 'Yes, our drivers are highly experienced and familiar with the best routes from Pune to Shirdi. They ensure a smooth, safe, and timely journey, making sure you arrive at your destination comfortably.'
          },
          {
            question: 'What payment options are available for booking a cab from Pune to Shirdi?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and secure online payments via our mobile app for your convenience.'
          },
          {
            question: 'Can I book a round trip from Pune to Shirdi?',
            answer: 'Yes, we offer round-trip bookings. Just provide us with your return details, and we’ll arrange for your return ride from Shirdi to Pune, ensuring a hassle-free experience.'
          },
          {
            question: 'Are there any extra charges for detours or waiting time during the trip?',
            answer: 'Any extra charges, such as for detours or waiting time, will be communicated to you upfront, ensuring full transparency in the pricing structure.'
          },
          {
            question: 'Can I make additional stops on the way to Shirdi?',
            answer: 'Yes, you can request additional stops. Please inform us during the booking process, and we’ll accommodate your requests for stops along the way.'
          },
          {
            question: 'What is the luggage allowance for a cab on the Pune to Shirdi trip?',
            answer: 'The Toyota Innova offers ample space for standard luggage. If you have more luggage or specific requirements, please let us know when booking, and we will make the necessary arrangements.'
          },
          {
            question: 'Does S9 Travels provide corporate travel services for Pune to Shirdi?',
            answer: 'Yes, we offer corporate travel services for business trips from Pune to Shirdi, ensuring that your journey is comfortable, punctual, and professional.'
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Shirdi cab booking?',
            answer: 'S9 Travels offers a reliable, safe, and comfortable ride with professional drivers, well-maintained vehicles, and excellent customer service, ensuring a smooth and enjoyable journey to Shirdi.'
          }
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Pradeep Sharma',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a ride from Pune to Shirdi with S9 Travels, and I couldn’t be more satisfied. The driver was professional, the car was clean, and the journey was comfortable. I highly recommend S9 Travels for anyone traveling to Shirdi!”'
        },
        {
          name: 'Mrs. Rupal Desai',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our family used S9 Travels for a trip to Shirdi from Pune, and the experience was excellent. The vehicle was spacious and clean, and the driver was courteous and punctual. I will definitely book again for our next trip!”'
        }
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
//  const productSchema = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Pune to Shirdi Cab",
//   "image": "/images/keyword/pune-to-shirdi.jpg",
//   "description": "Book Pune to Shirdi cab online at best prices with S9 Travels. Choose one-way or round-trip taxis with AC Sedans, SUVs, and Innova Crysta. Comfortable, safe, and timely travel to Shirdi Sai Baba Temple and Shani Shingnapur.",
//   "brand": { "@type": "Brand", "name": "S9 Travels" },
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.9",
//     "ratingCount": "6784"
//   },
//   "offers": {
//     "@type": "Offer",
//     "priceCurrency": "INR",
//     "price": "2499",
//     "availability": "https://schema.org/InStock",
//     "url": "https://s9travels.com/pune-to-shirdi-cab"
//   }
// };

      

    const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Pune to Shirdi Cab Service – S9 Travels",
    "image": "https://www.s9travels.com/images/keyword/pune-to-shirdi-cab.jpg",
    "description":
      "Book Pune to Shirdi cabs from ₹2499 with S9 Travels – your reliable partner for a smooth and comfortable journey to Sai Baba Temple. Choose from Hatchback, Sedan, SUV, or Innova Crysta. 24/7 customer support, clean AC cars, and verified chauffeurs ensure a safe, peaceful pilgrimage.",
    "brand": {
      "@type": "Brand",
      "name": "S9 Travels"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.9",
      "ratingCount": "6817"
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "INR",
      "price": "2499",
      "availability": "https://schema.org/InStock",
      "url": "https://www.s9travels.com/pune-to-shirdi-cab"
    }
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What is the fare for Pune to Shirdi cab?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "S9 Travels offers Pune to Shirdi cabs starting at ₹2499 for Hatchback, ₹2799 for Sedan, and ₹3299 for SUV or Innova Crysta. Transparent pricing with no hidden charges."
        }
      },
      {
        "@type": "Question",
        "name": "Is one-way Pune to Shirdi taxi available?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "Yes, S9 Travels provides one-way and round-trip Pune to Shirdi cab services 24x7. Perfect for temple visits, family trips, or weekend getaways."
        }
      },
      {
        "@type": "Question",
        "name": "How long does it take to reach Shirdi from Pune?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "The Pune to Shirdi journey covers around 185 km and takes approximately 4–5 hours via the smooth Ahmednagar highway. S9 Travels ensures punctual pickups and safe driving for a relaxed travel experience."
        }
      },
      {
        "@type": "Question",
        "name": "Do your cabs offer AC and music system?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "Yes, all S9 Travels cars are fully air-conditioned with music systems, GPS tracking, and comfortable seating to make your pilgrimage stress-free."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "S9 Travels",
    "image": "https://www.s9travels.com/images/logo.png",
    "url": "https://www.s9travels.com/",
    "telephone": "+91 7090759555",
    "priceRange": "₹₹",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Wakad Road, Pimpri-Chinchwad",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "postalCode": "411057",
      "addressCountry": "IN"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "ratingCount": "6817"
    },
    "openingHours": "Mo-Su 00:00-23:59",
    "areaServed":
      "Pune, Shirdi, Ahmednagar, Chakan, Hinjewadi, Pimpri Chinchwad, Kothrud, Hadapsar"
  };


  




    return (
        <div>

  <Helmet>
      {/* ✅ Title */}
      <title>
        Pune to Shirdi Cab from ₹2499 | One-Way Taxi, Sai Baba Temple Trips – S9 Travels
      </title>

      <meta
        name="description"
        content="Book Pune to Shirdi cabs from ₹2499 with S9 Travels. 24x7 safe and reliable taxi service for Sai Baba Temple visitors. Choose Hatchback, Sedan, SUV, or Innova Crysta with professional drivers and on-time pickup."
      />

      {/* ✅ Meta Keywords */}
      <meta
        name="keywords"
        content="Pune to Shirdi Cab, Pune to Shirdi Taxi, One Way Cab Pune to Shirdi, Pune to Shirdi Car Rental, Pune to Shirdi Innova, Pune to Shirdi SUV Cab, Pune to Shirdi Sedan Taxi, Pune to Shirdi Airport Drop, Online Cab Booking Pune to Shirdi, S9 Travels Pune to Shirdi Cab Service"
      />

      {/* ✅ Canonical */}
      <link rel="canonical" href="https://www.s9travels.com/pune-to-shirdi-cab" />

      {/* ✅ Product Schema */}
      <script type="application/ld+json">{JSON.stringify(productSchema)}</script>

      {/* ✅ FAQ Schema */}
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      {/* ✅ LocalBusiness Schema */}
      <script type="application/ld+json">{JSON.stringify(localBusinessSchema)}</script>

      {/* ✅ Open Graph Tags */}
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Pune to Shirdi Cab from ₹2499 | 24x7 Taxi & Temple Trips | S9 Travels"
      />
      <meta
        property="og:description"
        content="Book Pune to Shirdi cab service from ₹2499 with S9 Travels. AC cars, professional drivers, 24/7 support, and instant online booking for a peaceful Sai Baba Temple journey."
      />
      <meta
        property="og:image"
        content="https://www.s9travels.com/images/keyword/pune-to-shirdi-cab.jpg"
      />
      <meta property="og:url" content="https://www.s9travels.com/pune-to-shirdi-cab" />
      <meta property="og:site_name" content="S9 Travels" />

      {/* ✅ Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Pune to Shirdi Cab from ₹2499 | One-Way & Round-Trip Taxi | S9 Travels"
      />
      <meta
        name="twitter:description"
        content="Travel to Shirdi from Pune with S9 Travels starting at ₹2499. Clean cars, professional drivers, and 24x7 availability for Sai Baba Temple pilgrims."
      />
      <meta
        name="twitter:image"
        content="https://www.s9travels.com/images/keyword/pune-to-shirdi-cab.jpg"
      />
    </Helmet>
  

{/* <Helmet>
  <title>Pune to Shirdi Cab | One-Way & Round Trip Taxi from ₹2,499 | S9 Travels</title>
  <meta
    name="description"
    content="Book Pune to Shirdi cab online at best prices with S9 Travels. AC taxis, Innova, and SUVs available for one-way or round-trip. Safe, comfortable travel to Shirdi Sai Baba Temple and Shani Shingnapur with on-time pickup and professional drivers."
  />
  <meta
    name="keywords"
    content="Pune to Shirdi Cab, Pune to Shirdi Taxi, One Way Cab Pune to Shirdi, Round Trip Taxi Pune to Shirdi, Pune to Shirdi Innova Cab, SUV Taxi Pune to Shirdi, Cab Booking from Pune to Shirdi, Shirdi Sai Baba Cab from Pune, Affordable Taxi Pune Shirdi, S9 Travels Pune to Shirdi"
  />
  <link rel="canonical" href="https://s9travels.com/pune-to-shirdi-cab" />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet> 

// by this code showing 9:4 
*/}






             
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/90.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoshirdicab;